module.exports = __webpack_public_path__ + "img/DSC_0109.7cebe34a.jpg";